import "core-js/modules/web.dom-collections.for-each";
import baustein from "baustein";
import rothko from "web/script/modules/rothko";
import template from "templates/modules/product/related_products_loader.jinja";
import "web/script/components/tabbed-container";
import "web/script/components/tracked-link";
import "web/script/components/related-products-more-from-designer";
import "web/script/components/product-card";
import RelatedProductsShowMore from "web/react/components/related-products-show-more/related-products-show-more";
import renderReactComponentInDocument from "web/script/utils/render-react";
export default baustein.register("related-products-loader", {
  template: template,
  defaultOptions: {
    isOverlay: false,
    isInstock: false,
    isAffiliate: false,
    slug: null
  },
  getInitialRenderContext: function getInitialRenderContext() {
    return {
      related_products_loader: {
        is_loading: true,
        product_slug: null,
        related_products: null,
        is_overlay: false
      }
    };
  },
  onInsert: function onInsert() {
    var _this = this;

    if (this.el.querySelector(".related-products-area")) {
      return;
    }

    var _this$options = this.options,
        isOverlay = _this$options.isOverlay,
        isInstock = _this$options.isInstock,
        isAffiliate = _this$options.isAffiliate,
        slug = _this$options.slug;
    rothko.fetch("modules/product/related_products_loader", {
      isOverlay: isOverlay,
      isInstock: isInstock,
      isAffiliate: isAffiliate,
      slug: slug
    }).then(function (data) {
      _this.setRenderContext({
        related_products_loader: data
      });

      return data;
    }).then(function (data) {
      data.related_products.sections.forEach(function (section) {
        if (section.section_type !== null) {
          renderReactComponentInDocument(RelatedProductsShowMore, {
            view_more_url: section.view_more_url,
            product_is_instock: section.product_is_instock
          }, _this.el.querySelector("#related-products-show-more-button-" + section.section_type));
        }
      });
    });
  }
});